import { actionTypes } from "./constants";
const initialState = {
  groupList: [],
  curGroup: null,
  privilegeList: [],
  managerList: {
    list: [],
    total: 0,
  },
  jobPrivilege: [],
  managerListStrId: {
    list: [],
    total: 0,
  },
};

export default function reducer (state = initialState, action) {
  switch (action.type) {
    case actionTypes.SET_GROUPLIST:
      return {
        ...state, groupList: action.data, 
      };
    case actionTypes.SET_CURGROUP:
      return {
        ...state, curGroup: action.data, 
      };
    case actionTypes.SET_PRIVILEGELIST:
      return {
        ...state, privilegeList: action.data, 
      };
    case actionTypes.SET_MANAGERLIST:
      return {
        ...state, managerList: action.data, 
      };
    case actionTypes.SET_JOB_PRIVILEGE:
      return {
        ...state, jobPrivilege: action.data, 
      };
    case actionTypes.SET_MANAGERLIST_STR_ID:
      return {
        ...state, managerListStrId: action.data, 
      };
    default:
      return state;
  }
};